"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { ArrowRight } from "lucide-react";
export default function DataRoomIntro() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="data-room-intro" ref={ref} className="relative min-h-screen w-full flex items-center justify-center overflow-hidden bg-dark-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-[350ms] ease-[var(--ease-smooth)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1531884/img/accra_villa_luxury_render.png)",
      transform: isVisible ? "translateY(0)" : "translateY(5px)"
    }} />

      {}
      <div className="absolute inset-0 bg-primary/10" />

      {}
      <div className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}>
        {}
        <h1 className="font-display text-5xl md:text-6xl lg:text-7xl font-bold text-foreground-dark mb-6 group">
          <span className="inline-block relative">
            Access the Data Room
            <span className="absolute bottom-0 left-0 w-0 h-1 bg-accent transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] group-hover:w-full" />
          </span>
        </h1>

        {}
        <p className="text-lg md:text-xl text-foreground-dark/90 mb-8 leading-relaxed max-w-2xl mx-auto">
          Transparency is our foundation. Download verified land titles, view 24/7 live site cameras, and access GPS-stamped progress logs for every project. Trust is not a luxury—it is a guarantee.
        </p>

        {}
        <a href="https://glass-house-portal.vercel.app">
            <Button className="btn-primary text-base md:text-lg px-8 py-4 gap-2 hover:gap-3 transition-all" aria-label="Access secure data room">
              Enter Data Room
              <ArrowRight className="w-5 h-5" />
            </Button>
        </a>
      </div>

      {}
      <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-dark-background to-transparent" />
    </section>;
}